
  const grade = {
    path: "/grade",
    name: "grade",
    component: () => import(/* webpackChunkName: "grade" */ "@/components/grade/GradeIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "grade" */ "@/components/grade/GradeView.vue"), name: "gradeView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "grade" */ "@/components/grade/GradeEdit.vue"), name: "gradeEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "grade" */ "@/components/grade/GradeCreate.vue"), name: "gradeCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default grade;
    